import { render, staticRenderFns } from "./admin-freshdesk.vue?vue&type=template&id=9a09da08&scoped=true&"
import script from "./admin-freshdesk.vue?vue&type=script&lang=js&"
export * from "./admin-freshdesk.vue?vue&type=script&lang=js&"
import style0 from "./admin-freshdesk.vue?vue&type=style&index=0&id=9a09da08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a09da08",
  null
  
)

export default component.exports